import * as React from "react";
import { connect } from "react-redux";
import Component from "../../AbstractComponent";
import Constants from "../../../Action/Constants";
import Time from "../../../Time/Time";
import { Property } from "../../../Entity/Entities/Property/Property";
import { Unit } from "../../../Entity/Entities/Unit/Unit";
import { Charge } from "../../../Entity/Entities/Charge/Charge";
import { Event } from "../../../Entity/Entities/Event/Event";
import { PropertyInterface } from "../../../Entity/Entities/Property/PropertyInterface";
import { UnitInterface } from "../../../Entity/Entities/Unit/UnitInterface";
import { PersonInterface } from "../../../Entity/Entities/Person/PersonInterface";
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import { LeavePromptDialog } from "../../Partials/Dialog/LeavePromptDialog";
import { PageTransition } from "../../Partials/Spinner/PageTransition";
import { MiddlewareInterface } from "../../../Middleware/MiddlewareInterface";
import TaskCreateWillMount from "../../../Middleware/Middlewares/TaskCreateWillMount";
import PreventPageLeave from "../../../Middleware/Middlewares/PreventPageLeave";
import PersonLookup from "../../Partials/Lookup/PersonLookup";
import { Attachment } from "../../Partials/Attachment/Attachment";
import { DatePickerComponent } from "../../Partials/DatePicker/DatePickerComponent";
import Searchbar from "../../Partials/Searchbar/Searchbar";
import * as uuidV4 from "uuid/v4";
import { EventInterface } from "../../../Entity/Entities/Event/EventInterface";
import { CoachDialogNewExecutor } from "../../Partials/Dialog/CoachDialogNewExecutor";
import Select from "../../Partials/Material/Select";
import TextField from "../../Partials/Material/TextField";
import Card from '@material-ui/core/Card';
import Button from '@material-ui/core/Button';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import MenuItem from '@material-ui/core/MenuItem';

class TaskCreate extends Component {
  protected shouldClearBeforeUnmounting: boolean = true;
  protected clearWith: string = Constants.GLOBAL_EVENT_CREATE_CLEAR;
  protected person: PersonInterface;
  protected middlewares: MiddlewareInterface[] = [
    TaskCreateWillMount,
    PreventPageLeave
  ];

  public state = {
    task: null,
    instructions: "",
    details: "",
    reporterId: this.props?.app?.session?.user?.id,
    executorId: this.props?.app?.session?.user?.id,
    executionDate: null,
    attachments: [],
    events: [],
    fetchingEvents: true,
    removed: false,
    amazonFolderName:  uuidV4(),
    hasModifiedData: false,
    done: false,
    isFinishTaskPopupOpen: false,
    isUnFinishTaskPopupOpen: false,
    currentTaskUnit: "",
    currentTaskProperty: "",
    createdBy: null,
    isCreateTaskPreprocessPopupOpen: false,
    isSaving: false,
    nextPath: "",
    openLeavePrompt: false,
    selectedEntityForTask: null,
    selectedEntityForTaskManuallyChanged: false,
    disableObjectField: false,
    openPreTaskExecutorCoachDialog: false,
    executorType: "person",
    executorTypeСhoose: true,
    openTaskExecutorCoachDialog: false,
    eventTypeId: 35 // task // TODO fix hardcoded value
  }

  constructor(public props) {
    super(props);
  }

  public componentWillUnmount() {
    if (this.state.nextPath) {
      this.redirect(this.state.nextPath);
    }
  }

  public setTaskName = (event) => {
    const name = event.target.value;

    this.setState({
      instructions: name,
      hasModifiedData: true
    });
  }

  public selectPerson = (person: PersonInterface, isManuallySelected: boolean): void => {
    this.setState({
      executorId: person.id,
      hasModifiedData: isManuallySelected ? isManuallySelected : this.state.hasModifiedData,
    });
  }

  public clearPerson = (): void => {
    this.setState({
      executorId: null,
      hasModifiedData: true
    });
  }

  public selectReporter = (person: PersonInterface, isManuallySelected: boolean): void => {
    this.setState({
      reporterId: person.id,
      hasModifiedData: isManuallySelected ? isManuallySelected : this.state.hasModifiedData,
    });
  }

  public clearReporter = (): void => {
    this.setState({
      reporterId: null,
      hasModifiedData: true
    });
  }

  public selectDate = (momentDate: any, identifier: string): any => {
    const date = !!momentDate && typeof momentDate.toDate === "function" ? momentDate.toDate() : momentDate;

    this.setState({
      [identifier]: date,
      hasModifiedData: true
    });
  }

  public selectEntityForTask = (entity: PropertyInterface | UnitInterface): void => {
    this.setState({
      selectedEntityForTaskManuallyChanged: true,
      selectedEntityForTask: entity,
      hasModifiedData: true
    });
  }

  public clearEntityForTask = (): void => {
    this.setState({
      selectedEntityForTask: null,
      hasModifiedData: true
    });
  }

  public save = () => {
    const task: any = {
      content: {
        name: this.state.instructions,
        details: this.state.details,
      },
      executorId: this.state.executorId,
      executionDate: this.state.executionDate ? Time.formatOrNull(this.state.executionDate) : null,
      snoozeDate: this.state.executionDate ? Time.formatOrNull(this.state.executionDate) : null,
      reacted: false,
      amazonFolderName: this.state.amazonFolderName,
      reporterId: this.state.reporterId,
      eventTypeId: this.state.eventTypeId
    }

    if (this.state.selectedEntityForTask instanceof Property) {
      task.propertyId = this.state.selectedEntityForTask.id;
    }

    if (this.state.selectedEntityForTask instanceof Unit) {
      task.unitId = this.state.selectedEntityForTask.id;
    }

    if (this.state.selectedEntityForTask instanceof Charge) {
      task.chargeId = this.state.selectedEntityForTask.id;
    }

    if (this.state.selectedEntityForTask instanceof Event) {
      task.refersToEventId = this.state.selectedEntityForTask.id;
    }

    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_EVENT_CREATE_START,
        payload: {
          ...task
        },
        onSuccess: (task: EventInterface) => {
          // const executorId = this.state.executorId;

          // const executor = this.props.app.persons.filter((person: PersonInterface) => person.id === executorId)[0];

          // if (!!executor && !executor.email) {
          //   this.setState({
          //     isSaving: false
          //   })
          //
          //   return this.props.dispatch({
          //     type: Constants.SNACKBAR_ADD_MESSAGE,
          //     payload: {
          //       message: this.trans("postprocess/taskcreate-hint"),
          //       type: "info"
          //     }
          //   });
          // }

          this.setState({
            nextPath: `/app/task/update/${task.id}`
          }, this.redirectBack)
        },
        onError: () => {
          this.setState({
            hasModifiedData: true,
            isSaving: false
          });
        }
      });
    });
  }

  public getCoachContent = () => {
    return (
      <div>
        <div>
          {this.trans("coach/executor-scenario/company-step/first-info1")}
        </div>
        <div>
          <RadioGroup
            className="filters-container"
            value={this.state.executorType}
            onChange={this.chooseExecutorType}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
              padding: "10px 0 0 10px",
              width: "500px",
              paddingLeft: "0px"
            }}
          >
            {/* <FormControlLabel
              control={<Radio color="primary" />}
              value="user"
              label={this.trans("coach/executor-radiobutton/user")}
              style={{width: "auto", fontSize: "16px", marginRight: "20px"}}
            /> */}
            <FormControlLabel
              control={<Radio color="primary" />}
              value="person"
              label={this.trans("coach/executor-radiobutton/person")}
              style={{width: "auto", fontSize: "16px", marginRight: "20px"}}
            />
            <FormControlLabel
              control={<Radio color="primary" />}
              value="company"
              label={this.trans("coach/executor-radiobutton/company")}
              style={{width: "auto", fontSize: "16px", marginRight: "20px"}}
            />
            <FormControlLabel
              control={<Radio color="primary" />}
              value="department"
              label={this.trans("coach/executor-radiobutton/department")}
              style={{width: "auto", fontSize: "16px", marginRight: "20px"}}
            />
          </RadioGroup>
        </div>
        {/* <div>
          {this.trans("coach/executor-scenario/company-step/first-info2")}
        </div> */}
      </div>
    )
  }

  public chooseExecutorType = (event) => {
    const choice: string = event.target.value;

    this.setState({
      executorType: choice,
      executorTypeСhoose: true
    });
  }

  public onCloseCoach = () => {
    this.setState({
      openPreTaskExecutorCoachDialog: false,
      // executorTypeСhoose: true,
      openTaskExecutorCoachDialog: false
    })
  }

  public setExecutorFromCoach = (executor) => {
    this.setState({
      executorId: executor.id
    })
  }

  public openFirstStep = () => {
    this.setState({
      executorType: this.state.executorTypeСhoose ? this.state.executorType : "person",
      openPreTaskExecutorCoachDialog: true,
      openTaskExecutorCoachDialog: false
    })
  }

  public openTaskExecutorCoach = () => {
    if(this.state.executorType !== "user" || this.person.role && this.person.role.getRoleId() === 6) {
      this.setState({
        openPreTaskExecutorCoachDialog: false,
        openTaskExecutorCoachDialog: true
      })
    } else {
        this.props.dispatch({
          type: Constants.SNACKBAR_ADD_MESSAGE,
          payload: {
            message: this.trans("coach/executor-scenario/user-step/first-error"),
            type: "error"
          }
        });
        return;
    }
  }

  public updateEventTypeId = (event) => {
    const eventTypeId = event.target.value;

    return this.setState({
      eventTypeId: eventTypeId
    });
  }

  public render() {
    return (
      <div className="state-app">
        <div className="box box-full has-details-page-header">
          <div className="component-header has-back-button">
            <div className="inner-wrapper">
              <div className="back-arrow-wrapper" onClick={this.redirectBack}>
                <div className="icon icon-ic-arrow-back icon-color"></div>
              </div>
              <h1>{this.trans("task")}</h1>
              <div className="button-container-small">
                <Button
                  color="primary"
                  onClick={this.redirectBack}
                  style={{marginRight: "20px"}}
                  disabled={this.state.isSaving}
                >
                  {this.trans("button-cancel")}
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    // if (!!this.state.executorId && this.props.app.session.user.id !== this.state.executorId) {
                      // this.setState({isCreateTaskPreprocessPopupOpen: true});
                    // } else {
                      this.save();
                    // }
                  }}
                  disabled={this.state.isSaving}
                >
                  {this.trans("button-create")}
                </Button>
              </div>
            </div>
          </div>

          <div className="box component-task-update">
            <div className="component-wrapper no-margin-top no-shadow">
              <div className="component">
                <Card className="card">
                  <div className="row">
                    <div className="grid"></div>
                    <div className="grid">
                      <Select
                        className="form-element full-size scroll-to-eventTypeId"
                        error={this.getErrorFor("eventTypeId")}
                        value={this.state.eventTypeId}
                        onChange={this.updateEventTypeId}
                        htmlFor="eventTypeId"
                        label={this.trans("label-type")}
                        name="eventTypeId" 
                        id="eventTypeId"
                      >
                        {/* TODO fix hardcoded value */}
                        <MenuItem
                          key={`eventTypeId-${35}`}
                          value={35}
                        >
                          {this.trans("task")}
                        </MenuItem>
                        <MenuItem
                          key={`eventTypeId-${38}`}
                          value={38}
                        >
                          {this.trans("incident")}
                        </MenuItem>
                      </Select>

                      <TextField
                        autoComplete="off"
                        className="form-element full-size scroll-to-name"
                        type="text"
                        label={this.trans("label-description")}
                        value={this.state.instructions}
                        onChange={this.setTaskName}
                        autoFocus={true}
                        variant="standard"
                        multiline
                        rowsMax="25"
                        rows="1"
                        style={{marginBottom: "10px"}}
                        error={!!this.getErrorFor("content.name")}
                      />
                      {!!this.getErrorFor("content.name") && <div className="component-error-text">{this.getErrorFor("content.name")}</div>}

                      <PersonLookup
                        {...this.props}
                        autoSelectId={this.state.reporterId}
                        isInlineBlock={true}
                        width="100%"
                        containerWidth="100%"
                        ref="PersonLookup"
                        floatingLabelText={this.trans("reported-by") + this.trans("field/optional")}
                        labelText={this.trans("reported-by") + this.trans("field/optional")}
                        onSelect={this.selectReporter}
                        onClear={this.clearReporter}
                        forceUpdatePage={true}
                        saveDetailsBeforeRedirect={this.saveDetailsBeforeRedirect.bind(this, "taskCreate", "reporter")}
                        buttonLabel={this.trans("button-add-person")}
                        noResultText={this.trans("dropdown-person-notfound")}
                        templateFor={"person"}
                        includeUsers={true}
                      />

                      <PersonLookup
                        {...this.props}
                        autoSelectId={this.state.executorId}
                        isInlineBlock={true}
                        width="100%"
                        containerWidth="100%"
                        ref="PersonLookup"
                        floatingLabelText={this.trans("to-do-by") + this.trans("field/optional")}
                        labelText={this.trans("to-do-by") + this.trans("field/optional")}
                        onSelect={this.selectPerson}
                        onClear={this.clearPerson}
                        // forceUpdatePage={true}
                        saveDetailsBeforeRedirect={this.saveDetailsBeforeRedirect.bind(this, "taskCreate", "executor")}
                        buttonLabel={this.trans("button-add-executor")}
                        noResultText={this.trans("textfield-no-executor-found-click-add")}
                        templateFor={"executor"}
                        includeUsers={true}
                        shouldOpenCoachModal={true}
                        openTaskExecutorCoachDialog={() => this.setState({openPreTaskExecutorCoachDialog: true})}
                      />

                      <DatePickerComponent
                        {...this.props}
                        className="scroll-to-executionDate"
                        label={this.trans("show-me-from") + this.trans("field/optional")}
                        initialDate={this.state.executionDate}
                        onChange={date => this.selectDate(date, "executionDate")}
                        minDate={new Date()}
                        minDatePlusDays={0}
                        clearButton={true}
                        error={this.getErrorFor("executionDate")}
                      />

                      <div className="search-bar-container">
                        <Searchbar
                          {...this.props}
                          id="selectedEntityForNewTask"
                          className="scroll-to-objectId"
                          floatingLabelText={this.trans("object")}
                          allResults={true}
                          objectField={true}
                          onChange={this.selectEntityForTask}
                          onClear={this.clearEntityForTask}
                          searchText={this.state.selectedEntityForTask ? `${this.state.selectedEntityForTask.nameOfEntity}, ${this.state.selectedEntityForTask.displayName}` : undefined}
                          selectedEntity={this.state.selectedEntityForTask}
                          error={this.getErrorFor("objectId")}
                          searchParameter={"objectForTaskSearch"}
                          disabled={this.state.disableObjectField}
                        />
                      </div>
                    </div>
                  </div>
                </Card>
              </div>
            </div>

            <div className="component-wrapper no-shadow">
              <Attachment
                {...this.props}
                typeOfComponent="shared"
                title={this.trans("attachments-for-task")}
                relation="eventId"
                entity={this.state.task}
                amazonFolderName={!!this.state.amazonFolderName ? this.state.amazonFolderName : null}
                onLastImageDeleted={() => (this.refs.EntityAvatar as any) && (this.refs.EntityAvatar as any).revert()}
                updateParentState={attachments => this.setState({attachments: attachments})}
                disabled={this.state.removed || this.state.done}
                attachments={this.state.attachments}
              />
            </div>
          </div>
        </div>

        <PromptDialog
          {...this.props}
          title={this.trans("title-attention") + "!"}
          content={this.trans("preprocess/taskcreate-hint")}
          prioritizeClosing={true}
          openLeavePrompt={this.state.isCreateTaskPreprocessPopupOpen}
          negativeButtonLabel={this.trans("button-cancel")}
          positiveButtonLabel={this.trans("button-continue")}
          onDiscard={() => this.setState({isCreateTaskPreprocessPopupOpen: false})}
          onSave={() => this.setState({isCreateTaskPreprocessPopupOpen: false}, this.save)}
          hideCross={true}
        />

        <LeavePromptDialog
          {...this.props}
          prioritizeClosing={true}
          onClose={() => this.setState({ openLeavePrompt: false, nextPath: "" })}
          openLeavePrompt={this.state.openLeavePrompt}
          onDiscard={this.leave.bind(this)}
          onSave={() => { this.setState({ openLeavePrompt: false }); this.save(); }}
          hideCross={true}
          leavePrompt={true}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("coach/executor-title")}
          content={this.getCoachContent()}
          negativeButtonLabel={this.trans("dialog-button/cancel")}
          positiveButtonLabel={this.trans("coach/propertyowner-button/next")}
          openLeavePrompt={this.state.openPreTaskExecutorCoachDialog}
          prioritizeClosing={true}
          innerDialogClasses="dialog-assistant coach-executor"
          onDiscard={() => {
            this.setState({
              openPreTaskExecutorCoachDialog: false,
              // ownerType: "",
              // ownerTypeСhose: false
            });
          }}
          onSave={this.openTaskExecutorCoach}
          // diableContinueButton={!this.state.ownerTypeСhose}
        />

        <CoachDialogNewExecutor
          {...this.props}
          openTaskExecutorCoachDialog={this.state.openTaskExecutorCoachDialog}
          type={this.state.executorType}
          setExecutor={this.setExecutorFromCoach}
          openFirstStep={this.openFirstStep}
          onCloseCoach={this.onCloseCoach}
        />

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    properties: state.properties,
    units: state.units,
    events: state.events,
    component: state.eventCreate,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(
  TaskCreate
);
